import { render, staticRenderFns } from "./top-section.vue?vue&type=template&id=f1a82d1a"
import script from "./top-section.vue?vue&type=script&lang=js"
export * from "./top-section.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports